import {css} from '@emotion/react'
import {TextArea} from '@/components/Form'
import {useAiContext} from './AiContext.mjs'

const cssDraftText = css({
    minHeight: '56px !important',
})

export const DraftText = props => {
    const ai = useAiContext()

    const onChange = s => {
        const content = s.trim()
        ai.setDraft(d => ({...d, content}))
    }

    const onPressEnter = e => {
        if (
            e.altKey ||
            e.ctrlKey ||
            e.shiftKey ||
            ai.getIsRunning() ||
            ! ai.getIsReady()
        ) {
            return
        }

        e.preventDefault()
        ai.run()
    }

    return (
        <TextArea
            css={cssDraftText}
            autoSize={{minRows: 2, maxRows: 12}}
            bordered={false}
            disabled={ai.getIsDisabled()}
            value={ai.draft.content}
            onChange={onChange}
            onPressEnter={onPressEnter}
            {...props}
        />
    )
}
